module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/1c5455f1eb6e388cd51e33771e947106.png";